import { Link } from 'react-router-dom';
import { Post } from '@/hooks/usePosts';
import ArticleCard from '@/components/feature/ArticleCard';

interface LatestArticlesProps {
  posts: Post[];
}

export default function LatestArticles({ posts }: LatestArticlesProps) {
  const latest = posts.slice(0, 3);

  return (
    <section className="w-full bg-background-50 py-8 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <h2 className="font-heading font-bold text-foreground-950 text-lg md:text-2xl">
            Últimos artigos
          </h2>
          <Link
            to="/blog"
            className="
              text-primary-500 hover:text-primary-700 text-xs md:text-sm font-bold
              inline-flex items-center gap-1 cursor-pointer whitespace-nowrap
              transition-colors duration-200 group
            "
          >
            Ver todos{' '}
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
          </Link>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((post, i) => (
            <div
              key={post.id}
              className="animate-fade-in-up"
              style={{ animationDelay: `${i * 80}ms`, animationFillMode: 'both' }}
            >
              <ArticleCard post={post} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}